import { render, staticRenderFns } from "./SmartFaqModal.vue?vue&type=template&id=18509582"
import script from "./SmartFaqModal.vue?vue&type=script&lang=js"
export * from "./SmartFaqModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports